/**
 * `board-grid` schema (design §17, reserved since TDD §5.1) — a paintable W×H tile board:
 * match-3 starting boards, puzzle setups, tactics maps, farm plots. Cells are SPARSE
 * (absent = empty); `tile` values come from the board's own palette, whose entries are
 * ideally exact Content item names so cross-refs stay navigable.
 */
import { z } from 'zod';

const CellSchema = z.object({
  x: z.number().int().min(0),
  y: z.number().int().min(0),
  /** Palette entry this cell holds. */
  tile: z.string().min(1),
});

export const BoardGridLevelSchema = z.object({
  width: z.number().int().min(1).max(64),
  height: z.number().int().min(1).max(64),
  /** Tile vocabulary (exact Content item names preferred). */
  palette: z.array(z.string().min(1)).min(1),
  cells: z.array(CellSchema),
});

export type BoardGridLevel = z.infer<typeof BoardGridLevelSchema>;
export type BoardGridCell = z.infer<typeof CellSchema>;
